import { PROGRAMS, IMG } from "../lib/data";
import { Reveal, Overline } from "./Reveal";

export const Academics = () => (
  <section id="academics" data-testid="academics-section" className="relative py-28 lg:py-36 bg-cream-2">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <div className="max-w-2xl">
        <Reveal>
          <Overline>Academics</Overline>
          <h2 className="ff-display text-4xl md:text-6xl leading-[1] tracking-tight text-ink">
            A journey from first steps to board results.
          </h2>
        </Reveal>
      </div>

      <div className="mt-16 grid lg:grid-cols-3 gap-px bg-maroon/12 border border-maroon/12">
        {PROGRAMS.map((p, i) => (
          <Reveal key={p.stage} delay={i * 0.12}>
            <div className="bg-cream p-9 h-full min-h-[320px] flex flex-col group hover:bg-maroon transition-colors duration-500">
              <span className="text-xs uppercase tracking-[0.2em] text-maroon group-hover:text-saffron transition-colors">
                {p.grades}
              </span>
              <h3 className="ff-display text-3xl md:text-4xl mt-3 text-ink group-hover:text-cream transition-colors">
                {p.stage}
              </h3>
              <p className="mt-5 text-ink/70 group-hover:text-cream/80 leading-relaxed font-light transition-colors">
                {p.text}
              </p>
              <span className="mt-auto pt-6 ff-display text-6xl text-maroon/10 group-hover:text-cream/20 transition-colors">
                0{i + 1}
              </span>
            </div>
          </Reveal>
        ))}
      </div>

      <div className="mt-20 grid md:grid-cols-2 gap-6 lg:gap-10 items-stretch">
        <Reveal>
          <figure className="relative h-full">
            <img src={IMG.traditional} alt="Traditional grounding" className="w-full h-72 md:h-full object-cover" />
            <figcaption className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-black/70 to-transparent p-6">
              <span className="ff-display text-2xl text-cream">Traditional Grounding</span>
              <p className="text-cream/75 text-sm mt-1 font-light">Sanskrit · Yoga · Values · Classical Arts</p>
            </figcaption>
          </figure>
        </Reveal>
        <Reveal delay={0.12}>
          <figure className="relative h-full md:mt-12">
            <img src={IMG.modern} alt="Modern learning" className="w-full h-72 md:h-full object-cover" />
            <figcaption className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-black/70 to-transparent p-6">
              <span className="ff-display text-2xl text-cream">Modern Learning</span>
              <p className="text-cream/75 text-sm mt-1 font-light">Science Labs · Computing · Inquiry · English</p>
            </figcaption>
          </figure>
        </Reveal>
      </div>
    </div>
  </section>
);
